// extracted by mini-css-extract-plugin
module.exports = {"sizeItem":"SizeItem_sizeItem__7ViPk","selectable":"SizeItem_selectable__J5zws"};